const styles = {
  App: {
    display: 'flex !important',
    flexDirection: 'column !important',
    textAlign: 'center !important',
  },
};

export default styles;
